import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import TopBar from './components/layout/TopBar';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import Home from './pages/Home';
import Services from './pages/Services';
import About from './pages/About';
import ForBusiness from './pages/ForBusiness';
import FAQ from './pages/FAQ';
import Contact from './pages/Contact';
import Admin from './pages/Admin';
import Reschedule from './pages/Reschedule';
import Cancel from './pages/Cancel';
import ServiceDetail from './pages/ServiceDetail';
import PatientForms from './pages/PatientForms';
import HipaaNotice from './pages/HipaaNotice';
import Policies from './pages/Policies';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

const Chrome = ({ children }) => {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith('/admin');
  return (
    <>
      {!isAdmin && <TopBar />}
      {!isAdmin && <Header />}
      <main>{children}</main>
      {!isAdmin && <Footer />}
    </>
  );
};

function App() {
  return (
    <div className="App bg-white min-h-screen">
      <BrowserRouter>
        <ScrollToTop />
        <Chrome>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/:slug" element={<ServiceDetail />} />
            <Route path="/about" element={<About />} />
            <Route path="/for-business" element={<ForBusiness />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/patient-forms" element={<PatientForms />} />
            <Route path="/hipaa-notice" element={<HipaaNotice />} />
            <Route path="/policies" element={<Policies />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/reschedule/:token" element={<Reschedule />} />
            <Route path="/cancel/:token" element={<Cancel />} />
          </Routes>
        </Chrome>
      </BrowserRouter>
    </div>
  );
}

export default App;
